import type { StaticImageData } from 'next/image';
import type { LinkProps } from 'next/link';

import { ourClientsCompaniesList } from '@/assets/clients/our-clients-companies/ourClientsCompaniesList';

export type CaseStudyListItem = {
  slug: string;
  href: LinkProps['href'];
  companyName: string;
  tagline: string;
  industry: string;
  category: string;
  logo: StaticImageData;
  coverImage: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
};

export const caseStudies: CaseStudyListItem[] = [
  {
    slug: 'pegasus',
    href: '/case-studies/pegasus',
    companyName: 'Pegasus Solar',
    tagline:
      'A manufacturer’s design tool, rebuilt into a reason to specify their hardware',
    industry: 'Manufacturing - building and construction components',
    category: 'Manufacturing',
    logo: ourClientsCompaniesList.pegasus,
    coverImage: {
      src: '/case-studies/pegasus/hero-design-tool.jpg',
      alt: 'Pegasus Solar design tool open on a laptop, showing roof and equipment inputs',
      width: 2000,
      height: 1500,
    },
  },
];
